import { render, staticRenderFns } from "./VegeIssueView.vue?vue&type=template&id=2fcfd26b&scoped=true"
import script from "./VegeIssueView.vue?vue&type=script&lang=ts"
export * from "./VegeIssueView.vue?vue&type=script&lang=ts"
import style0 from "./VegeIssueView.vue?vue&type=style&index=0&id=2fcfd26b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfd26b",
  null
  
)

export default component.exports